import { RouteObject } from "react-router-dom";

export const INTERNATIONAL_WIRE_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { InternationalWireManager } = await import("./IntlWireManager");
      return { element: <InternationalWireManager /> };
    },
  },
];
